import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { FIX_SESSION_BASE_PATH } from '../../../../../../../../../features/fix/session/fix-session-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'fix-session-list',
        label: 'OMS',
        to: FIX_SESSION_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
